import { Typography, List, ListItem } from '@material-tailwind/react';
import { ENTITY_MAP } from '@/constants/permission-entities';

const PermissionEntitiesSidebar = ({ selectedEntity, onSelect }) => {
  const entities = Object.keys(ENTITY_MAP).map((key) => ({
    type: key,
    label: ENTITY_MAP[key].label,
  }));

  return (
    <div className="w-72 bg-gray-50 p-4 rounded-lg h-[532px] overflow-y-auto">
      <Typography variant="h6" className="mb-4">
        Entidades
      </Typography>
      <List className="min-h-[400px]">
        {entities.map((entity) => (
          <ListItem
            key={entity.type}
            onClick={() => onSelect(entity.type)}
            selected={selectedEntity === entity.type}
            className="hover:bg-blue-50 focus:bg-blue-100"
          >
            {entity.label}
          </ListItem>
        ))}
      </List>
    </div>
  );
};

export default PermissionEntitiesSidebar;